/**
 * PageSizeSelector — Reusable page-size dropdown for paginated lists.
 *
 * Extracted from Transactions.tsx [T81P1-b] so all paginated pages share
 * the same component and 44px-minimum touch target.
 */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface PageSizeSelectorProps {
  value: number;
  onChange: (size: number) => void;
  options?: number[];
  label?: string;
}

export default function PageSizeSelector({
  value,
  onChange,
  options = [10, 20, 50, 100],
  label = 'Show',
}: PageSizeSelectorProps) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs text-muted-foreground select-none">{label}</span>
      <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger className="h-9 w-[68px] text-xs px-2">
          <SelectValue />
        </SelectTrigger>
        <SelectContent align="end" side="top">
          {options.map((n) => (
            <SelectItem key={n} value={String(n)} className="text-xs">
              {n}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className="text-xs text-muted-foreground select-none hidden sm:inline">per page</span>
    </div>
  );
}
